export enum MessageType {
    INFO = 'info',
    WARNING = 'warn',
    ERROR = "error",
    SUCCESS = "success"
}